import { Stack, Typography, Button } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ETenderStatus, ITender } from 'types/tender'
import { TenderCountdown } from './tender-countdown'
import EastIcon from '@mui/icons-material/East'
import { useNavigate } from 'react-router-dom'
import { TenderGeneralInfo } from './tender-general-info'
import { EOrganizationType, IUser } from 'types/users'
import { toast } from 'react-toastify'
import { ParticipationFee } from './lots/participation-fee'
import { usePaymentPayerStatusQuery } from 'services/payment'
import { Loading } from 'components/Loading'
import { EPaymentPayerStatus } from 'types/payments'
import { useMySubmissionsQuery } from 'services/submissions'
import { SubmissionStatusIndicator } from 'pages/tender-participation/lots/submission-status-indicator'

type Props = {
  tender: ITender
  isTermsAccepted: boolean
  user?: IUser
  isSubmissionTimePassed: boolean
  passedStartDate: boolean
}

export const TenderParticipationGeneralInfo = ({
  tender,
  isTermsAccepted,
  user,
  isSubmissionTimePassed,
  passedStartDate,
}: Props) => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { data: submissionData } = useMySubmissionsQuery({ lotId: tender.lot.id })

  const { data: paymentPayerStatus, isLoading } = usePaymentPayerStatusQuery(
    { lotId: tender.lot.id },
    { skip: !tender }
  )

  if (isLoading) {
    return <Loading fullPage={false} />
  }

  return (
    <Stack spacing={2}>
      <TenderGeneralInfo tender={tender} />
      <TenderCountdown tender={tender} />
      {user?.organizationType === EOrganizationType.CLIENT && (
        <>
          {passedStartDate &&
            tender.status !== ETenderStatus.EVALUATION_SUBMITTED && (
              <ParticipationFee
                lot={tender.lot}
                participationFee={tender.lot.participationFeeAmount}
                paymentPayerStatus={paymentPayerStatus}
                isSubmissionTimePassed={isSubmissionTimePassed}
              />
            )}

          {!!submissionData && (
            <SubmissionStatusIndicator submission={submissionData} />
          )}

          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            sx={{ backgroundColor: 'primary.main', p: 2 }}
          >
            <Stack spacing={1}>
              <Typography variant="body2" color="white">
                {`${t('lot-name')}: ${tender.lot.name}`}
              </Typography>
              <Typography variant="body2" color="white">
                {`${t('status')}: -`}
              </Typography>
            </Stack>
            {passedStartDate &&
              isTermsAccepted &&
              paymentPayerStatus?.status === EPaymentPayerStatus.AUTHORIZED && (
                <Button
                  onClick={() => {
                    if (!user?.organizationTaxId) {
                      toast.error(t('org-tax-id-msg'))
                    } else {
                      navigate(
                        `/portal/tender-participation/${tender.id}/lots/${tender.lot.id}`
                      )
                    }
                  }}
                  variant="contained"
                  style={{ color: '#fff', backgroundColor: 'rgb(3, 34, 76)' }}
                  sx={{ color: '#FFF', border: '1px solid #FFF' }}
                >
                  <EastIcon />
                </Button>
              )}
          </Stack>
        </>
      )}
    </Stack>
  )
}
